class SubcollectionsList{
  constructor(){
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {

    this.moreButton = document.querySelector('.js__subcollections-more-button');
    this.subcollections = document.querySelector('.js__subcollections-container');

    if (!this.moreButton || !this.subcollections) {
      return;
    }

    this.moreButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.showMore();
    });
  }

  showMore() {
    this.subcollections.classList.toggle('show');
    this.moreButton.classList.toggle('show');
  }
}

new SubcollectionsList();